import { useEffect, useRef } from 'react';

/** Keep the scrollbar buttons clear of the header, including when column resizing wraps it. */
export default function useScrollbarHeaderHeight() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = ref.current;
    const header = container?.querySelector('thead');
    if (!container || !header) return undefined;
    const update = () =>
      container.style.setProperty('--scrollbar-header-height', `${header.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);
  return ref;
}
